export default "__VITE_ASSET__C2RajUI8__"